type LegalRow = Record<string, any> | null | undefined

export function canGeneratePflichten(row: LegalRow, isHmcAdmin: boolean) {
  if (!isHmcAdmin) return false

  const landId = Number(row?.id_Land)
  if (landId === 2 || landId === 6) return true

  return landId === 1 && String(row?.pcode ?? '').trim().startsWith('DE-MUN-')
}

export function hasRequiredPflichtenStandardTexts(row: LegalRow) {
  return Number(row?.id_Land) !== 2 || row?.hasStandardtexts === true
}

export function pflichtenGenerationPath(row: LegalRow, rechtsgrundlageId: number) {
  const landId = Number(row?.id_Land)
  const action = landId === 1
    ? 'generate_municipal_german_pflichten'
    : landId === 2
      ? 'generate_austrian_pflichten'
      : 'generate_taiwan_pflichten'
  return `/rechtsgrundlagen/${rechtsgrundlageId}/${action}.json`
}
